import { useMutation } from "@apollo/client";
import {
  Button,
  ButtonGroup,
  ControlGroup,
  NumericInput,
} from "@blueprintjs/core";
import _ from "lodash";
import { useState } from "react";
import {
  Article,
  ArticlePrice,
  ArticlePriceTier,
  CreateArticlePriceInput,
} from "../../../../api/schema";
import { valid_number_keys } from "../../../../components/form/builder/OrderPositions";
import { ValuesVariables } from "../../../../components/form/InputForm";
import { CreateArticlePriceMutation } from "../../helper/graphql";

interface CreatePriceRowProps {
  visible: boolean;
  article?: Article;
  price_tier: ArticlePriceTier;
  on_created: () => void;
  on_cancel: () => void;
}

export const CreatePriceRow = (props: CreatePriceRowProps) => {
  const [create_article_price] = useMutation<
    ArticlePrice,
    ValuesVariables<CreateArticlePriceInput>
  >(CreateArticlePriceMutation);

  const [price_state, set_price_state] = useState<CreateArticlePriceInput>({
    article_id: props.article?.id || 0,
    article_price_tier_id: props.price_tier.id,
    price: 1,
    quantity: 1,
  });

  const reset = () =>
    set_price_state({
      article_id: props.article?.id || 0,
      article_price_tier_id: props.price_tier.id,
      price: 1,
      quantity: 1,
    });

  const create_price = () => {
    if (!props.article) return;

    create_article_price({
      variables: {
        values: { ...price_state, article_id: props.article.id },
      },
    }).then((res) => {
      // console.log("create article price", res);
      if (res.data) {
        reset();
        props.on_created();
      }
    });
  };

  // console.log("price_state", price_state);

  if (!props.visible) return null;

  const qty_exists =
    _.find(props.price_tier.prices, (p) => {
      // console.log("checking ", p);

      return p.quantity === price_state.quantity;
    }) !== undefined;

  return (
    <div className="aw_ap_row">
      <ControlGroup>
        <div className="aw_ap_qty">
          <NumericInput
            value={price_state.quantity}
            leftIcon="numerical"
            onValueChange={(e) =>
              set_price_state({ ...price_state, quantity: e })
            }
            min={1}
            fill
          />
        </div>
        <div className="aw_ap_price">
          <NumericInput
            fill
            value={price_state.price}
            leftIcon="euro"
            allowNumericCharactersOnly={false}
            asyncControl
            onBlur={(e) => {
              try {
                const n = parseFloat(
                  (e.target as HTMLInputElement).value.split(",").join(".")
                );
                set_price_state({ ...price_state, price: n });
              } catch {}
            }}
            onKeyDown={(e) => {
              const value = e.currentTarget.value;
              if (
                (e.key === "." || e.key === ",") &&
                (_.indexOf(value, ".") !== -1 || _.indexOf(value, ",") !== -1)
              )
                e.preventDefault();

              if (
                _.indexOf(
                  valid_number_keys.filter((s) => s !== "-"),
                  e.key
                ) === -1
              ) {
                e.preventDefault();
                return;
              }
              if (e.key === "Enter" || e.key === "Tab") {
                try {
                  const n = parseFloat(
                    e.currentTarget.value.split(",").join(".")
                  );
                  set_price_state({ ...price_state, price: n });
                } catch {}
              }
            }}
          />
        </div>
      </ControlGroup>
      <ButtonGroup>
        <Button
          intent="success"
          icon="plus"
          disabled={qty_exists}
          onClick={create_price}
        />
        <Button
          intent="danger"
          icon="cross"
          onClick={() => {
            reset();
            props.on_cancel();
          }}
        />
      </ButtonGroup>
    </div>
  );
};
